import URI from "./URI";

const mockedURIs = []

const mockData = {
  [URI.userDetails]: {
    "data": {
      "user": {
        "ID": 544,
        "createdAt": "2024-07-23T13:38:17.799903+05:30",
        "UpdatedAt": "2024-08-20T17:01:08.530489+05:30",
        "deletedAt": null,
        "email": "vamsiswaroopsr@gmail.com",
        "emailVerified": true,
        "phone": "9444687855",
        "phoneVerified": true,
        "referral": null,
        "source": null,
        "uniqueCientCode": "T7808799",
        "onboarding": {
          "ID": 488,
          "createdAt": "2024-07-23T13:41:24.692121+05:30",
          "updatedAt": "2024-08-01T18:41:51.064347+05:30",
          "deletedAt": null,
          "currentStep": "panvalidation",
          "provider": "hyperverge",
          "activated": true,
          "activated_at": "2024-07-23T22:13:49.09+05:30",
          "hypervergeApplicationStatus": "auto_approved",
          "approvedAt": "2024-07-23T14:43:09.687034+05:30",
          "hypervergeTransactionID": "T7808799",
          "hypervergeUUID": "10e945d3-a827-47f8-853f-bbaead7e8d25",
          "hypervergePushedAt": "2024-07-23T14:43:09.687034+05:30",
          "hypervergeUpdatedAt": "2024-07-23T14:43:09.687034+05:30",
          "cimsUan": 92061,
          "pushedToCIMS": true,
          "pushedToCIMSAt": "2024-07-23T14:43:09.704763+05:30",
          "pushedToTechExcel": null,
          "ushedToTechExcelAt": null,
          "activationRemarks": null,
          "dp": "1209480000005001",
          "latitude": "19.0748",
          "longitude": "72.8856",
          "ipAddress": "103.19.197.46",
          "firstName": "VAMSISWAROOP",
          "middleName": null,
          "lastName": "SRIDHARAN",
          "failReason": "",
          "panNumber": "NBIPS9677H",
          "nameAsITD": "VAMSISWAROOP SRIDHARAN",
          "kraVerified": false,
          "KRASearchedAt": null,
          "dob": null,
          "nameAsKRA": "VAMSISWAROOP SRIDHARAN",
          "fathersNameAsKRA": "",
          "correspondenceAddress": null,
          "permanentAddress": null,
          "fatherName": "Sridharan D",
          "runningAccount": null,
          "maritalStatus": "Single",
          "tradingExperience": "No Experience",
          "grossAnnualIncome": "10-25 Lac",
          "occupation": "Private Sector Service",
          "sourceOfWealth": "Private Sector Service",
          "taxResidencyOtherThanIndia": false,
          "politicallyExposedPerson": false,
          "relatedPoliticallyExposedPerson": false,
          "askedForDISBooklet": false,
          "digioKID": "",
          "digioRefferenceID": "",
          "digioAccessToken": "",
          "nameAsDigilockerPan": "VAMSISWAROOP SRIDHARAN",
          "dobAsDigilockerPan": "1998-06-22T05:30:00+05:30",
          "genderAsDigilockerPan": "",
          "dobAsDigilockerAadhaar": "1998-06-22T05:30:00+05:30",
          "nameAsDigilockerAadhaar": "Vamsiswaroop Sridharan",
          "maskedAadhaarNumberAsDigilocker": "xxxxxxxx1551",
          "maskedAadhaarImageAsDigilocker": null,
          "MaskedAadhaarImageAsDigilockerID": null,
          "maskedAadhaarPDFAsDigilocker": null,
          "MaskedAadhaarPDFAsDigilockerID": 951,
          "aadhaarXMLFileAsDigilocker": null,
          "AadhaarXMLFileAsDigilockerID": 952,
          "panVerifiedWithOCR": false,
          "panImageAsDigilocker": null,
          "PanImageAsDigilockerID": null,
          "panPDFAsDigilocker": null,
          "PanPDFAsDigilockerID": 953,
          "currentAddressAsDigilockerAadhaar": null,
          "permanentAddressAsDigilockerAadhaar": null,
          "genderAsDigilockerAadhaar": "M",
          "bankOnePrimary": false,
          "bankAccountNumber": "921010056381464",
          "bankBranch": "SHNATIGRAM TOWN SHIP ADALAJ",
          "bankAddress": "SHOP NO 22 GROUND FLOOR SHOPPERS PLAZA SHANTIGRAM NR VAISHNAV DEVI TEMPLE S G HIGHWAY",
          "bankName": "AXIS BANK",
          "bankIFSCNumber": "UTIB0003414",
          "uploadedCheque": null,
          "UploadedChequeID": null,
          "micrCode": "",
          "nameAsBank": "VAMSISWAROOP SRIDHARAN",
          "BankVerifiedAt": null,
          "bankTwoPrimary": false,
          "bankAccountNumberTwo": null,
          "bankBranchTwo": null,
          "bankAddressTwo": null,
          "bankNameTwo": null,
          "bankIFSCNumberTwo": null,
          "uploadedChequeTwo": null,
          "UploadedChequeTwoID": null,
          "micrCodeTwo": null,
          "bankThreePrimary": false,
          "bankAccountNumberThree": null,
          "bankBranchThree": null,
          "bankAddressThree": null,
          "bankNameThree": null,
          "bankIFSCNumberThree": null,
          "uploadedChequeThree": null,
          "UploadedChequeThreeID": null,
          "micrCodeThree": null,
          "vpaID": "vamsiswaroopsr-1@okicici",
          "optedForEquitySegment": true,
          "optedForMutualFund": true,
          "OptedForDrivativesSegment": false,
          "optedForBSEFO": null,
          "pptedForNSEFO": null,
          "derivativesDocumentName": "",
          "derivativesDocument": null,
          "DerivativesDocumentID": null,
          "derivatives_account_aggregator_data": null,
          "totalNominiees": 0,
          "nominieesAdded": false,
          "nominieeOneName": "",
          "nominieeOneIsMinor": false,
          "nominieeOneRelation": "",
          "nominieeOneDob": null,
          "nominieeOneIDProof": "",
          "nominieeOneIDProofDetails": "",
          "nominieeOnePanNumber": "",
          "nominieeOneAddressLine1": "",
          "nominieeOneAddressLine2": "",
          "nominieeOneAddressLine3": "",
          "nominieeOneCity": "",
          "nominieeOneState": "",
          "nominieeOneCountry": "",
          "nominieeOnePinCode": "",
          "nominieeOneMobile": "",
          "nominieeOneEmail": "",
          "nominieeOneAllocation": 0,
          "nominieeOneGuardianRelation": "",
          "nominieeOneGuardianDOB": null,
          "nominieeOneGuardianIDProof": "",
          "nominieeOneGuardianIDProofDetails": "",
          "nominieeOneGuardianMobile": "",
          "nominieeOneGuardianEmail": "",
          "nominieeOneGuardianPinCode": "",
          "nominieeOneGuardianAddressLine1": "",
          "nominieeOneGuardianAddressLine2": "",
          "nominieeOneGuardianAddressLine3": "",
          "nominieeOneGuardianCity": "",
          "nominieeOneGuardianState": "",
          "NominieeOneGuardianCountry": "",
          "nominieeOneGuardianName": "",
          "nominieeTwoName": "",
          "nominieeTwoIsMinor": false,
          "nominieeTwoRelation": "",
          "nominieeTwoDob": null,
          "nominieeTwoPanNumber": "",
          "nominieeTwoIDProof": "",
          "nominieeTwoIDProofDetails": "",
          "nominieeTwoAddressLine1": "",
          "nominieeTwoAddressLine2": "",
          "nominieeTwoAddressLine3": "",
          "nominieeTwoPinCode": "",
          "nominieeTwoAllocation": 0,
          "nominieeTwoMobile": "",
          "nominieeTwoEmail": "",
          "nominieeTwoGuardianMobile": "",
          "nominieeTwoGuardianEmail": "",
          "nominieeTwoGuardianRelation": "",
          "nominieeTwoGuardianDOB": null,
          "nominieeTwoGuardianIDProof": "",
          "nominieeTwoGuardianIDProofDetails": "",
          "nominieeTwoGuardianAddressLine1": "",
          "nominieeTwoGuardianAddressLine2": "",
          "nominieeTwoGuardianAddressLine3": "",
          "nominieeTwoGuardianCity": "",
          "nominieeTwoGuardianState": "",
          "nominieeTwoGuardianCountry": "",
          "nominieeTwoCity": "",
          "nominieeTwoState": "",
          "nominieeTwoCountry": "",
          "nominieeTwoGuardianPinCode": "",
          "nominieeTwoGuardianName": "",
          "nominieeThreeName": "",
          "nominieeThreeIsMinor": false,
          "nominieeThreeRelation": "",
          "nominieeThreeDob": null,
          "nominieeThreePanNumber": "",
          "nominieeThreeIDProof": "",
          "nominieeThreeIDProofDetails": "",
          "nominieeThreeAddressLine1": "",
          "nominieeThreeAddressLine2": "",
          "nominieeThreeAddressLine3": "",
          "NominieeThreeCity": "",
          "NominieeThreeState": "",
          "NominieeThreeCountry": "",
          "nominieeThreePinCode": "",
          "nominieeThreeAllocation": 0,
          "nominieeThreeMobile": "",
          "nominieeThreeEmail": "",
          "nominieeThreeGuardianMobile": "",
          "nominieeThreeGuardianEmail": "",
          "nominieeThreeGuardianRelation": "",
          "nominieeThreeGuardianDOB": null,
          "nominieeThreeGuardianIDProof": "",
          "nominieeThreeGuardianIDProofDetails": "",
          "nominieeThreeGuardianAddressLine1": "",
          "nominieeThreeGuardianAddressLine2": "",
          "nominieeThreeGuardianAddressLine3": "",
          "nominieeThreeGuardianCity": "",
          "nominieeThreeGuardianState": "",
          "nominieeThreeGuardianCountry": "",
          "nominieeThreeGuardianPinCode": "",
          "nominieeThreeGuardianName": "",
          "selfie": null,
          "SelfieID": 954,
          "livelinessSessionID": "",
          "signature": null,
          "SignatureID": 955,
          "string": "https://torus-superapp.s3.ap-south-1.amazonaws.com/production/userssvc/onboarding/signatures/compressed-df27280c-fdf0-4499-9a52-cd38cf32e598.jpeg",
          "accountOpeningForm": null,
          "AccountOpeningFormID": null,
          "digioDID": "",
          "SignedAccountOpeningForm": null,
          "esignedAt": null,
          "SignedAccountOpeningFormID": 956,
          "UserID": 544
        },
        "digiGoldOnboarding": {
          "ID": 197,
          "createdAt": "2024-08-20T17:01:08.531963+05:30",
          "updatedAt": "2024-08-20T17:01:08.531963+05:30",
          "deletedAt": null,
          "currentStep": "panvalidation",
          "failReason": null,
          "approved": null,
          "autoApproved": false,
          "aID": "",
          "approvedBy": null,
          "ApprovedByID": null,
          "status": "Pending",
          "partnerCode": "",
          "agentCode": "",
          "panNumber": "",
          "nameAsITD": "",
          "dob": null,
          "nameAsbank": "",
          "bankAccountNumber": "",
          "bankIFSCNumber": "",
          "addressLine1": "",
          "addressLine2": "",
          "addressLine3": "",
          "addressCity": "",
          "addressDistrict": "",
          "addressPinCode": 0,
          "addressState": "",
          "addressCountry": "",
          "uploadedCheque": null,
          "UploadedChequeID": null,
          "UserID": 544,
          "User": null
        },
        "emailModifications": [
          {
            "id": 1,
            "oldEmail": "vamsiswaroopsr@gmail.com",
            "newEmail": null,
            "hypervergeTransactionID": "emailmodification-T7808799-3b7643d1-762f-4944-ac4f-7452171165ab",
            "hyperverge_application_status": null,
            "created_at": "2024-08-20T17:00:47.191664+05:30",
            "updated_at": "2024-08-20T17:00:47.191664+05:30",
            "deletedAt": null,
            "status": "started",
            "current": false,
            "inSyncWithCIMS": false,
            "inlineFile": null,
            "pushedToTechExcel": false,
            "pushedToTechExcelAt": null,
            "modificationRemarks": null,
            "esignedPDF": null,
            "EsignedPDFID": null,
            "applicationDate": null,
            "UserID": 544
          },
          {
            "id": 12,
            "oldEmail": "vamsiswaroopsr@gmail.com",
            "newEmail": null,
            "hypervergeTransactionID": "emailmodification-T7808799-1727777507",
            "hyperverge_application_status": null,
            "created_at": "2024-10-01T15:41:47.923386+05:30",
            "updated_at": "2024-10-10T16:44:16.790161+05:30",
            "deletedAt": null,
            "status": "started",
            "current": false,
            "inSyncWithCIMS": false,
            "inlineFile": null,
            "pushedToTechExcel": false,
            "pushedToTechExcelAt": null,
            "modificationRemarks": null,
            "esignedPDF": null,
            "EsignedPDFID": null,
            "applicationDate": null,
            "UserID": 544
          },
          {
            "id": 15,
            "oldEmail": "vamsiswaroopsr@gmail.com",
            "newEmail": null,
            "hypervergeTransactionID": "emailmodification-T7808799-1728558856",
            "hyperverge_application_status": null,
            "created_at": "2024-10-10T16:44:16.79073+05:30",
            "updated_at": "2024-10-10T16:44:16.79073+05:30",
            "deletedAt": null,
            "status": "started",
            "current": true,
            "inSyncWithCIMS": false,
            "inlineFile": null,
            "pushedToTechExcel": false,
            "pushedToTechExcelAt": null,
            "modificationRemarks": null,
            "esignedPDF": null,
            "EsignedPDFID": null,
            "applicationDate": "2024-10-10T16:44:16.789865+05:30",
            "UserID": 544
          }
        ],
        "phoneModifications": [
          {
            "id": 37,
            "oldPhone": "9444687855",
            "newPhone": null,
            "hypervergeTransactionID": "phonemodification-T7808799-1727777504",
            "hyperverge_application_status": null,
            "created_at": "2024-10-01T15:41:44.229294+05:30",
            "updated_at": "2024-10-10T16:46:31.708218+05:30",
            "DeletedAt": null,
            "status": "started",
            "current": false,
            "inSyncWithCIMS": false,
            "inlineFile": null,
            "pushedToTechExcel": false,
            "pushedToTechExcelAt": null,
            "modificationRemarks": null,
            "esignedPDF": null,
            "EsignedPDFID": null,
            "applicationDate": null,
            "UserID": 544
          },
          {
            "id": 42,
            "oldPhone": "9444687855",
            "newPhone": null,
            "hypervergeTransactionID": "phonemodification-T7808799-1728558991",
            "hyperverge_application_status": null,
            "created_at": "2024-10-10T16:46:31.708808+05:30",
            "updated_at": "2024-10-10T16:46:31.708808+05:30",
            "DeletedAt": null,
            "status": "started",
            "current": true,
            "inSyncWithCIMS": false,
            "inlineFile": null,
            "pushedToTechExcel": false,
            "pushedToTechExcelAt": null,
            "modificationRemarks": null,
            "esignedPDF": null,
            "EsignedPDFID": null,
            "applicationDate": "2024-10-10T16:46:31.707971+05:30",
            "UserID": 544
          }
        ],
        "bankAccountModifications": [],
        "segmentModifications": [],
        "accountClosures": [],
        "plan": ""
      },
      "mfProfile": {
        "data": {
          "mainDetails": [
            {
              "ClientID": 190,
              "ClientCode": "CL00000190",
              "FamilyName": "VAMSISWAROOP  SRIDHARAN",
              "ClientName": "VAMSISWAROOP   SRIDHARAN",
              "Gender": "Not Available",
              "DOB": "22 Jun 1998",
              "PAN": "NBIPS9677H",
              "MobileNo": "",
              "EmailID": "vamsiswaroopsr@gmail.com",
              "IsFamilyHead": false,
              "KYCValid": false,
              "KYCFormNo": "0",
              "KYCNumber": "",
              "PlaceOfBirth": "NA",
              "CountryOfBirth": "",
              "Occupation": "NA",
              "Address": "SRIDHARAN DHAMODHARAN 18 4TH CROSS, STREET ANUGRAHA SATELLITE TOWNSHIP, PERIYAKATTUPALAYAM CUDDALORE TAMIL NADU",
              "AccountTypeID": 1,
              "MemberSince": "29 Aug 2024"
            }
          ],
          "familyMembers": null,
          "personalDetails": null,
          "bankDetails": [
            {
              "UCC": "T7808799",
              "ID": 131,
              "ClientID": 190,
              "AccountType": "SB",
              "BranchName": "SHNATIGRAM TOWN SHIP ADALAJ",
              "BankName": "AXIS BANK",
              "IFSCCode": "UTIB0003414",
              "BranchMICRCode": "380211069",
              "BankAccountNumber": "921010056381464",
              "IsDefault": true
            }
          ],
          "mandateDetails": [
            {
              "Amount": 50000,
              "BankAccNo": "921010056381464",
              "BankBranch": "SHNATIGRAM TOWN SHIP ADALAJ",
              "BankName": "AXIS BANK",
              "Ct": 1,
              "IFSC": "UTIB0003414",
              "L5ID": 0,
              "MandateId": "42010848",
              "MandateStatus": "APPROVED",
              "RegistrationDate": "27 Sep 2024",
              "UCC": "T7808799"
            }
          ],
          "nominee": null,
          "accountDetails": [
            {
              "UCC": "T7808799",
              "L5ID": 131,
              "MutualFundUCC": "T7808799",
              "TaxStatus": "Individual",
              "HoldingNature": "Single",
              "EmailID": "vamsiswaroopsr@gmail.com",
              "MobileNo": "9444687855",
              "Gender": "Not Available",
              "MemberSince": "29 Aug 2024",
              "Nationality": "Indian"
            }
          ],
          "jointHolderDetails": null,
          "taxDetails": null,
          "uccList": [
            {
              "ID": 131,
              "ClientID": 190,
              "ClientCode": "T7808799",
              "ClientName": "VAMSISWAROOP  SRIDHARAN",
              "SecondApplicantName": "  ",
              "TertiaryName": "  ",
              "DisplayName": "Single",
              "ClientStatus": "1",
              "UCCStatus": "ACTIVE",
              "MemberCode": "59272"
            }
          ],
          "clientBankDetails": [
            {
              "AccountHolderTypeID": 4,
              "AccountType": 1,
              "BANKID1": "UTI",
              "BankAccountNumber": "921010056381464",
              "BankAccountTypeDontUse": 0,
              "BankID": 117,
              "BankIDDirect": "UTI",
              "BankIDNodal": "UTI",
              "BankIDUPI": "UTI",
              "BankLogo": "",
              "BankName": "AXIS BANK",
              "BatchNumber": "",
              "BranchMICRCode": 0,
              "ClientID": 190,
              "CreatedOn": "2024-08-29T11:51:07.497",
              "DIRECTAllowed": true,
              "ID": 12801,
              "ID1": 117,
              "IFSCCode": "UTIB0003414",
              "IsActive": true,
              "IsDefaullt": false,
              "ModifiedOn": "1900-01-01T00:00:00",
              "NODAL": false,
              "NRISubTypeID": 0,
              "SourceFrom": "UCC",
              "UPIAllowed": true
            }
          ],
          "guardianDetails": null,
          "status": "S",
          "message": "SUCCESS"
        }
      },
      "hasMPIN": true
    }
  },
  [URI.userInvestments]: {
    "mutualFunds": {
        // "hasError": true,
        // "message": "Failed to retrieve MF Portfolio data"
        "investment": 1234345,
        "current": 34590345,
        "unRealizedGainLoss": 234646457,
        "unRealizedGainLossPercent": 550.4,
        "realizedGainLoss": -2345346346,
        "realizedGainLossPercent": 345346,
        "todayPnL": 345345345,
        "todayPnLPercent": 4354.363
    },
    "stocks": {
        "hasError": true,
        "message": "Failed to retrieve MF Portfolio data"
    },
    "fno": {
        "hasError": true,
        "message": "Failed to retrieve F&O data"
    },
    "total": {
        "investment": 1234345,
        "current": 34590345,
        "unrealizedGainLoss": 234646457,
        "unrealizedGainLossPercent": 550.4,
        "realizedGainLoss": -2345346346
    }
  },
  [URI.userBankDetails]: {
    "actDtls": [
        {
            "accountId": "251007013054",
            "type": "1043",
            "group": "SAV",
            "productClass": "S",
            "balance": "60",
            "originalAmount": "",
            "boo": "10011",
            "availBalance": "53.00",
            "acctName": "NISHANT  GARG",
            "nominalIntRat": "",
            "currencyCode": "INR",
            "relCode": "A",
            "custrelcode": "",
            "relationType": "M",
            "operateMode": "1",
            "accountStatus": "A",
            "accountSolId": "10011",
            "schemeDescription": "INSTA SAVINGS ACCOUNT",
            "accountCloseDate": "",
            "accountCloseFlag": "N",
            "accountFreezeStatus": "",
            "accountFreezeType": "",
            "depositAmount": "",
            "availableAmount": "",
            "maturityDate": "",
            "interestRate": "0",
            "nomineeName": "LOKENDRA KUMAR GARG",
            "nomineeAvailableFlag": "Y",
            "totalDisbursedAmount": "0",
            "emiAmount": "0",
            "emiNextDate": "",
            "lienId": "DC591696",
            "relatedPartyDetails": {}
        }
    ],
    "custDtls": [
        {
            "employeeCode": "",
            "customerId": "250791964",
            "firstName": "NISHANT",
            "title": "Mr.",
            "middleName": "",
            "lastName": "GARG",
            "ckycNumber": "40003127819791",
            "address1": "S/O Lokendra Kumar Garg 22",
            "address2": ".,.",
            "address3": ".",
            "city": "JAIPU",
            "state": "RJ",
            "country": "IN",
            "pincode": "302018",
            "dob": "15-11-2001",
            "emailId": "gargnishant09@gmail.com",
            "aadhaarNumber": "110003065893",
            "panNumber": "DHGPG5673H",
            "branchCode": "10011",
            "registeredMobile": "9079843110",
            "kycType": "PAN",
            "internetBankingEnabled": "ENABLE",
            "mobileBankingEnabled": "NOT ASSIGN",
            "whatsAppEnabled": "ENABLE",
            "languagePreference": "India (English)",
            "customerNetWorthCurrencyCode": "INR",
            "customerNetWorth": "59"
        }
    ]
  }
}

const mockedResponses = mockedURIs.reduce((responseMap,uri)=>{
  responseMap[uri] = mockData[uri]
  return responseMap
},{})

export default mockedResponses;
